// extracted by mini-css-extract-plugin
module.exports = {"close":"modal-close__close___2bZOR","modal-content":"modal-close__modal-content___1hEe-","modalContent":"modal-close__modal-content___1hEe-"};